/* eslint-disable */
/**
 *  This is to initialize a product page meter for a particular group.We need to create meter instance for both mobile and desktop screens, hence you can see forloop for each meter with having data-screens as mobile and desktop
 *
 * @param {number} defaultAdded - The default step which needs to be take
 * @param {number} TotalComp - The total step of the meter
 * @param {string} groupId - The groupid of a particular product pack group page
 * ...
 * @returns {void} - It returns void.
 * @throws {undefined} - Groupid is must for initialzing the meter
 */

const checkmarkIcon = `<img src="/assets/images/icons/meter-check-icon.svg" alt="check-icon">`;

export const initMeter = (
  defaultAdded,
  TotalComp,
  groupId,
  isPackSummary = false
) => {
  const meterSelector = isPackSummary
    ? `.meter.meter-pack-summary[data-groupid='${groupId}']`
    : `.meter[data-groupid='${groupId}']`;

  const bar = `bar_${groupId}`;

  $(`${meterSelector}`).each(function (e) {
    const screen = $(this).data("screen");

    window[`${bar}-${screen}`] = new ldBar(
      `${meterSelector}[data-screen=${screen}]`,
      {
        preset: "circle",
        "stroke-width": "8",
        "stroke-trail-width": "8",
        stroke: "#137a8c",
        "stroke-linecap": "round",
        type: "stroke",
        "fill-dir": "ltr",
        "pattern-size": "30",
        value: (defaultAdded / TotalComp) * 100,
      }
    );

    const labelSelector = `${meterSelector} .ldBar-label`;
    const label = $(labelSelector);
    label.each(function (e) {
      if (defaultAdded < TotalComp) {
        $(this).text(`${defaultAdded}/${TotalComp}`);
      } else {
        $(this).text("");
        $(this).html(checkmarkIcon);
      }
    });
  });
};

/**
 *  This updates the meter of a particular product pack page.
 *
 * @param {number} value - The current step which needs to be take
 * @param {number} maxStep - The total step of the meter. default max step is taken as 1.
 * @param {string} groupId - The groupid of a particular product pack group page
 * ...
 * @returns {void} - It returns void.
 * @throws {undefined} - Groupid is must for initialzing the meter
 */

export const updateMeter = (value, maxStep = 1, groupId) => {
  if (!groupId) {
    return;
  }

  const totalPercentage = 100;
  const fillValue = (value / maxStep) * totalPercentage;
  $(`.meter[data-groupid='${groupId}']`).each(function () {
    const screen = $(this).data("screen");
    const label = $(
      `.meter[data-groupid='${groupId}'][data-screen='${screen}'] .ldBar-label`
    );
    label.text(`${value}/${maxStep}`);
    window[`bar_${groupId}-${screen}`].set(fillValue, true);

    if (value < maxStep) {
      label.text(`${value}/${maxStep}`);
      $("#meter-announcer").text(`${value} of ${maxStep} products selected for the group`);
    } else {
      label.text("");
      label.html(checkmarkIcon);
      $("#meter-announcer").text(`All ${maxStep} products selected for the group`);
    }
  });
};
